import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTextFieldsComponent } from "./med-icon-text-fields.component";

@NgModule({
  declarations: [
    MedIconTextFieldsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTextFieldsComponent,
  ],
})
export class MedIconTextFieldsModule { }
